import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import DrinkSearchAutocomplete from './DrinkSearchAutocomplete';
// Menu functionality removed - POS systems handle menus
import womanProfileIcon from '../assets/avatar_no_background.png';
import ezdrinkLogo from '../assets/ez-logo-ultra-thin.svg';
import PreferenceQuestion from './PreferenceQuestion';
import FestivalGuideConversation from './FestivalGuideConversation';
import FeaturedVendors from './FeaturedVendors';
import FestivalMap from './FestivalMap';
import VendorMenu from './VendorMenu';
import { 
  generateVerificationCode, 
  sendVerificationCode, 
  storeVerificationCode,
  verifyPhoneCode 
} from '../services/snsService';
// Import customer bridge service to fetch real vendors
import { getAllRealVendors, checkPointBHealth } from '../services/customerBridgeService';


// Styled components for the chat interface

// New styled components for order history items
const HistoryItemsContainer = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
`;

const HistoryItem = styled.div`
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #222;
    border-color: #D4AF37;
  }
  
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HistoryItemDetails = styled.div`
  flex-grow: 1;
`;

const HistoryItemName = styled.div`
  font-weight: 500;
  color: white;
`;

const HistoryItemPrice = styled.div`
  font-size: 14px;
  color: #D4AF37;
  margin-left: 8px;
`;

const HistoryItemType = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

const HistoryTitle = styled.h4`
  color: #D4AF37;
  margin: 6px 0;
  font-size: 14px;
`;

const ReorderButton = styled.button`
  background-color: transparent;
  border: 1px solid #D4AF37;
  color: #D4AF37;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #D4AF37;
    color: black;
  }
`;

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 10px;
  background-color: #0a0a0a; /* Darker black to match website */
  border-radius: 10px;
  border: 1px solid #333;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  width: 80%;
  max-width: 600px;
  margin: 20px auto;
  z-index: 10;
`;

const Avatar = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  border: 1px solid #D4AF37;
`;

const MessageBubble = styled.div`
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 5px;
  background-color: ${({ sender }) => (sender === 'user' ? '#D4AF37' : '#1a1a1a')};
  color: ${({ sender }) => (sender === 'user' ? 'black' : 'white')};
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: ${({ sender }) => (sender === 'user' ? 'fit-content' : '100%')};
  margin-left: ${({ sender }) => (sender === 'user' ? 'auto' : '0')};
  ${({ sender }) => sender === 'user' ? 'border-bottom-right-radius: 0;' : 'border-bottom-left-radius: 0;'}
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-top: 1px solid #333;
  background-color: #0a0a0a; /* Darker black to match website */
  border-radius: 0 0 10px 10px;
`;

const InputField = styled.input`
  flex-grow: 1;
  padding: 8px;
  border: 1px solid #333;
  border-radius: 5px;
  margin-right: 10px;
  font-size: 14px;
  background-color: #1a1a1a; /* Slightly lighter than main background */
  color: white;
  &:focus {
    outline: none;
    border-color: #D4AF37;
    box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.25);
  }
  &::placeholder {
    color: #888;
  }
`;

const SendButton = styled.button`
  padding: 8px 15px;
  background: linear-gradient(135deg, #d4af37, #f5d76e, #926f34);
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: bold;
  &:hover {
    background: linear-gradient(135deg, #926f34, #f5d76e, #d4af37);
  }
  &:disabled {
    background: #5D4A1F;
    color: #ccc;
    cursor: not-allowed;
  }
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 10px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  filter: drop-shadow(0 0 5px rgba(212, 175, 55, 0.5));
`;

const InputRow = styled.div`
  display: flex;
  width: 100%;
`;

const MessagesContainer = styled.div`
  overflow-y: auto;
  max-height: 400px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #0a0a0a; /* Darker black to match website */
  border-radius: 10px 10px 0 0;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #1a1a1a;
  }
  &::-webkit-scrollbar-thumb {
    background: #D4AF37;
    border-radius: 3px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

const ActionButton = styled.button`
  padding: 8px 15px;
  background-color: #1a1a1a;
  color: #D4AF37;
  border: 1px solid #D4AF37;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background-color: #D4AF37;
    color: black;
  }
`;

const MessageContent = styled.div`
  flex-grow: 1;
  p {
    margin: 0;
    line-height: 1.4;
  }
`;

const DrinkMenu = styled.div`
  margin-top: 10px;
  background-color: #1a1a1a;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #333;
`;

const DrinkItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 8px;
  border-bottom: 1px solid #333;
  &:last-child {
    border-bottom: none;
  }
  cursor: pointer;
  &:hover {
    background-color: #2A2A2A;
  }
`;

const DrinkDetails = styled.div`
  flex-grow: 1;
  h4 {
    margin: 0;
    font-size: 16px;
    color: white;
  }
  p {
    margin: 4px 0 0;
    color: #AAA;
    font-size: 14px;
  }
`;

const DrinkPrice = styled.span`
  font-weight: bold;
  color: #D4AF37;
`;

// Styled components for menu categories
const CategorySelector = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: #1a1a1a;
  }
  &::-webkit-scrollbar-thumb {
    background: #D4AF37;
    border-radius: 2px;
  }
`;

const CategoryButton = styled.button`
  padding: 6px 12px;
  background-color: #1a1a1a;
  color: #D4AF37;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 13px;
  white-space: nowrap;
  
  &:hover {
    background-color: #2A2A2A;
  }
  
  &.active {
    background-color: #D4AF37;
    color: black;
  }
`;

const DrinkCategory = styled.div`
  font-size: 12px;
  color: #D4AF37;
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// Styled components for the payment form
const PaymentFormContainer = styled.div`
  background-color: #1a1a1a;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
  border: 1px solid #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
`;

const PaymentFormTitle = styled.h3`
  font-size: 18px;
  margin: 0 0 16px 0;
  color: #D4AF37;
`;

const OrderSummary = styled.div`
  background-color: #121212;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  color: white;
`;

const FormGroup = styled.div`
  margin-bottom: 12px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #CCC;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background-color: #222;
  color: white;
  &:focus {
    outline: none;
    border-color: #D4AF37;
    box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.25);
  }
  &:disabled {
    background-color: #2A2A2A;
    cursor: not-allowed;
  }
  &::placeholder {
    color: #666;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 12px;
`;

const FormColumn = styled.div`
  flex: 1;
`;

const PaymentFormButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #222;
  color: #CCC;
  border: 1px solid #444;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: #333;
  }
  &:disabled {
    background-color: #1a1a1a;
    color: #666;
    cursor: not-allowed;
  }
`;

const PayButton = styled.button`
  flex: 1;
  padding: 10px;
  background: linear-gradient(135deg, #d4af37, #f5d76e, #926f34);
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
  &:hover {
    background: linear-gradient(135deg, #926f34, #f5d76e, #d4af37);
  }
  &:disabled {
    background-color: #5D4A1F;
    color: #AAA;
    cursor: not-allowed;
  }
`;

// New styled components for quantity selection
const QuantitySelector = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #1a1a1a;
  border-radius: 8px;
  border: 1px solid #333;
`;

const QuantityTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 10px;
  color: #D4AF37;
  font-size: 16px;
`;

const QuantityButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
`;

const QuantityButton = styled.button`
  padding: 8px 15px;
  background-color: ${props => props.selected ? '#D4AF37' : '#222'};
  color: ${props => props.selected ? 'black' : '#D4AF37'};
  border: 1px solid #D4AF37;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${props => props.selected ? '#B8860B' : '#333'};
  }
`;

const OrderSummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: white;
`;

const OrderTotal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #444;
  font-weight: bold;
  color: #D4AF37;
`;

const UpsellContainer = styled.div`
  margin-top: 15px;
  padding: 10px;
  background-color: #222;
  border-radius: 6px;
  border: 1px solid #444;
`;

const UpsellTitle = styled.p`
  color: #D4AF37;
  margin-bottom: 10px;
  font-weight: 500;
`;

const UpsellButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`;

const GoldButton = styled(ActionButton)`
  background: linear-gradient(135deg, #d4af37, #f5d76e);
  color: black;
  font-weight: bold;
  border: none;
  
  &:hover {
    background: linear-gradient(135deg, #B8860B, #d4af37);
    color: black;
  }
`;

// NEW: CSS animations for notifications
const slideInKeyframes = `
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

// Inject the keyframes into the document
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = slideInKeyframes;
  document.head.appendChild(style);
}

// New styled component for festival guide overlay
const FestivalGuideOverlay = styled.div`
  position: relative;
  background-color: #1a1a1a;
  border-radius: 8px;
  border: 2px solid #D4AF37;
  margin: 15px 0;
  padding: 10px;
  z-index: 50;
`;

// Main ChatWindow component
const ChatWindow = ({ messages, onSendMessage, onButtonClick, inputType, currentUser, isProcessing, globalCart, onAddToGlobalCart, onRemoveFromGlobalCart, onUpdateGlobalCartQuantity, getCartItemsForVendor }) => {
  const [input, setInput] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [menuCategories, setMenuCategories] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    name: ""
  });
  
  // State variables for quantity selection
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [showQuantitySelector, setShowQuantitySelector] = useState(false);
  const [selectedDrink, setSelectedDrink] = useState(null);
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
  
  // State for festival guide
  const [showFestivalGuide, setShowFestivalGuide] = useState(false);
  
  // State for featured vendors
  const [showFeaturedVendors, setShowFeaturedVendors] = useState(false);
  
  // State for festival map
  const [showFestivalMap, setShowFestivalMap] = useState(false);
  
  // State for vendor menu
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showVendorMenu, setShowVendorMenu] = useState(false);
  
  // NEW: State for real vendors from customer-bridge-lambda
  const [realVendors, setRealVendors] = useState([]);
  const [vendorsLoading, setVendorsLoading] = useState(false);
  const [vendorsError, setVendorsError] = useState(null);
  const [lastVendorRefresh, setLastVendorRefresh] = useState(null);
  const [previousVendorCount, setPreviousVendorCount] = useState(0);
  const [showNewVendorNotification, setShowNewVendorNotification] = useState(false);
  
  const messagesEndRef = useRef(null);
  // Menu data removed - POS systems handle menus

  // NEW: Fetch vendors from customer-bridge-lambda
  const fetchVendors = async () => {
    try {
      console.log('🔍 [DEBUG] Starting vendor fetch process...');
      setVendorsLoading(true);
      setVendorsError(null);
      
      console.log('🔄 [DEBUG] Calling getAllRealVendors() from customerBridgeService...');
      const vendors = await getAllRealVendors();
      
      console.log('📊 [DEBUG] Raw response from getAllRealVendors:', vendors);
      console.log('📊 [DEBUG] Response type:', typeof vendors);
      console.log('📊 [DEBUG] Response length:', vendors?.length);
      console.log('📊 [DEBUG] Is array?', Array.isArray(vendors));
      
      if (vendors && vendors.length > 0) {
        console.log(`✅ [DEBUG] Successfully fetched ${vendors.length} vendors from customer-bridge-lambda`);
        console.log('📋 [DEBUG] Vendor details:', vendors.map(v => ({
          id: v.id,
          name: v.name,
          posSystem: v.posSystem,
          onboardingDate: v.onboardingDate
        })));
        
        // Check if new vendors were added
        if (realVendors.length > 0 && vendors.length > realVendors.length) {
          const newVendors = vendors.filter(newVendor => 
            !realVendors.some(existingVendor => existingVendor.id === newVendor.id)
          );
          
          if (newVendors.length > 0) {
            console.log(`🎉 [DEBUG] ${newVendors.length} new vendor(s) detected:`, newVendors);
            setShowNewVendorNotification(true);
            
            // Auto-hide notification after 5 seconds
            setTimeout(() => setShowNewVendorNotification(false), 5000);
          }
        }
        
        setPreviousVendorCount(realVendors.length);
        setRealVendors(vendors);
        setLastVendorRefresh(new Date());
        
        console.log('✅ [DEBUG] Vendor state updated successfully');
        console.log('✅ [DEBUG] Current vendor count:', vendors.length);
        console.log('✅ [DEBUG] Previous vendor count:', realVendors.length);
      } else {
        console.log('⚠️ [DEBUG] No vendors returned from customer-bridge-lambda');
        console.log('⚠️ [DEBUG] This might indicate an issue with Point B or EventBridge');
        setRealVendors([]);
      }
    } catch (error) {
      console.error('❌ [DEBUG] Error fetching vendors from customer-bridge-lambda:', error);
      console.error('❌ [DEBUG] Error name:', error.name);
      console.error('❌ [DEBUG] Error message:', error.message);
      console.error('❌ [DEBUG] Error stack:', error.stack);
      setVendorsError(error.message);
      setRealVendors([]);
    } finally {
      setVendorsLoading(false);
      console.log('🔍 [DEBUG] Vendor fetch process completed');
    }
  };

  // NEW: Check customer-bridge-lambda health
  const checkLambdaHealth = async () => {
    try {
      console.log('🏥 [DEBUG] Starting lambda health check...');
      const health = await checkPointBHealth();
      console.log('🏥 [DEBUG] Raw health response:', health);
      console.log('🏥 [DEBUG] Health response type:', typeof health);
      console.log('🏥 [DEBUG] Health response keys:', Object.keys(health || {}));
      console.log('🏥 [DEBUG] Is healthy?', health?.healthy);
      console.log('🏥 [DEBUG] Status code:', health?.status);
      console.log('🏥 [DEBUG] Status text:', health?.statusText);
      console.log('🏥 [DEBUG] Error details:', health?.error);
      
      const isHealthy = health.healthy;
      console.log(`🏥 [DEBUG] Customer-bridge-lambda health check result: ${isHealthy ? '✅ HEALTHY' : '❌ UNHEALTHY'}`);
      
      if (!isHealthy) {
        console.warn('⚠️ [DEBUG] Lambda health check failed - this may affect vendor data');
        console.warn('⚠️ [DEBUG] Health check details:', health);
      }
      
      return isHealthy;
    } catch (error) {
      console.error('❌ [DEBUG] Lambda health check failed:', error);
      console.error('❌ [DEBUG] Error name:', error.name);
      console.error('❌ [DEBUG] Error message:', error.message);
      console.error('❌ [DEBUG] Error stack:', error.stack);
      return false;
    }
  };

  // NEW: Refresh vendors (called manually or on timer)
  const refreshVendors = async () => {
    console.log('🔄 Manual vendor refresh requested...');
    await fetchVendors();
  };

  // NEW: Auto-refresh vendors every 30 seconds to catch new connections
  useEffect(() => {
    // Initial fetch
    fetchVendors();
    
    // Set up auto-refresh timer
    const refreshInterval = setInterval(() => {
      console.log('🔄 Auto-refreshing vendors...');
      fetchVendors();
    }, 30000); // 30 seconds
    
    return () => clearInterval(refreshInterval);
  }, []);

  // NEW: Check for new vendors and show notifications
  useEffect(() => {
    if (realVendors.length > 0 && lastVendorRefresh) {
      // This effect runs when vendors are updated
      // You could add logic here to detect new vendors and show notifications
      console.log(`✅ Vendor list updated: ${realVendors.length} vendors available`);
    }
  }, [realVendors, lastVendorRefresh]);

  // NEW: Real-time connection status
  const [isRealTimeConnected, setIsRealTimeConnected] = useState(false);
  
  useEffect(() => {
    // Simulate real-time connection status
    // In a real implementation, this would be connected to WebSocket or EventSource
    const realTimeInterval = setInterval(() => {
      setIsRealTimeConnected(prev => !prev);
    }, 2000); // Toggle every 2 seconds to simulate real-time updates
    
    return () => clearInterval(realTimeInterval);
  }, []);

  // NEW: Check lambda health on component mount
  useEffect(() => {
    checkLambdaHealth();
  }, []);

  // Debug: Log state changes for festival guide
  useEffect(() => {
    console.log("showFestivalGuide changed to:", showFestivalGuide);
  }, [showFestivalGuide]);

  // Menu functionality removed - POS systems handle menus

  // Auto-scroll to bottom when messages change
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Format phone number as the user types
  const formatPhoneNumber = (value) => {
    const phone = value.replace(/\D/g, '');
    if (phone.length < 4) return phone;
    if (phone.length < 7) return `(${phone.slice(0,3)}) ${phone.slice(3)}`;
    return `(${phone.slice(0,3)}) ${phone.slice(3,6)}-${phone.slice(6,10)}`;
  };

  // Handle user input in the chat input field
  const handleInputChange = (e) => {
    let value = e.target.value;
    if (inputType === 'phone') {
      value = formatPhoneNumber(value);
    }
    setInput(value);
  };

  // Handle form submission for the chat input
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    
    // Keep the existing behavior
    onSendMessage(input);
    
    // Add just this SMS functionality for phone input type
    if (inputType === 'phone') {
      // Generate and send verification code
      const code = generateVerificationCode();
      sendVerificationCode(input, code);
      storeVerificationCode(input, code);
    }
    
    setInput('');
  };

  // Handle category selection
  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId === selectedCategory ? null : categoryId);
  };

  // Format card number with spaces as the user types
  const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || "";
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      return parts.join(" ");
    } else {
      return value;
    }
  };

  // Format expiry date as the user types
  const formatExpiryDate = (value) => {
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    if (v.length >= 2) {
      return v.slice(0, 2) + "/" + v.slice(2, 4);
    }
    return v;
  };

  // Handle input changes in the payment form
  const handlePaymentInputChange = (field, value) => {
    let formattedValue = value;
    
    if (field === 'cardNumber') {
      formattedValue = formatCardNumber(value);
    } else if (field === 'expiryDate') {
      formattedValue = formatExpiryDate(value);
    }
    
    setPaymentDetails(prev => ({
      ...prev,
      [field]: formattedValue
    }));
  };

  // Handle drink selection
  const handleDrinkSelection = (drinkJson, type = 'selection') => {
    const drink = JSON.parse(drinkJson);
    setSelectedDrink(drink);
    setSelectedQuantity(1);
    setShowQuantitySelector(true);
    setShowOrderConfirmation(false);
  };

  // Handle selecting an item from the festival guide
  const handleItemFromGuide = (item) => {
    console.log("Selected item from guide:", item);
    
    // Hide the festival guide
    setShowFestivalGuide(false);
    
    // Handle different types of selections
    if (item.action === 'show_menu') {
      // Show the menu for the selected category
      onButtonClick('show_menu');
    } else if (item.type) {
      // Handle category-specific actions
      onButtonClick(`show_${item.type}`);
    }
  };

  // Handle selecting a vendor from featured vendors
  const handleVendorFromFeatured = (vendor) => {
    console.log("Selected vendor from featured:", vendor);
    
    // Hide the featured vendors
    setShowFeaturedVendors(false);
    
    // Handle different vendor actions
    if (vendor.action === 'show_vendor_menu') {
      // Show the specific vendor's menu
      onButtonClick('show_menu', { vendor: vendor.id });
    } else if (vendor.action === 'show_full_menu') {
      // Show the full festival menu
      onButtonClick('show_menu');
    }
  };

  // Handle selecting a vendor from festival map
  const handleVendorFromMap = (vendor) => {
    console.log("Selected vendor from map:", vendor);
    
    // Hide the festival map
    setShowFestivalMap(false);
    
    // Check if this vendor has Square integration
    const squareVendors = ['bbq-smokehouse', 'craft-cocktails', 'taco-fiesta'];
    
    if (squareVendors.includes(vendor.id)) {
      // Show Square menu for this vendor
      setSelectedVendor(vendor);
      setShowVendorMenu(true);
    } else {
      // Handle vendor selection with original behavior
      if (vendor.action === 'show_vendor_menu') {
        // Show the specific vendor's menu
        onButtonClick('show_menu', { vendor: vendor.id });
      }
    }
  };

  // Handle quantity selection
  const handleQuantitySelect = (quantity) => {
    setSelectedQuantity(quantity);
  };

  // Handle confirming quantity
  const handleConfirmQuantity = () => {
    handleProceedToPayment();
  };

  // Handle proceeding to payment
  const handleProceedToPayment = () => {
    // Create enhanced drink object with quantity information
    const enhancedDrink = {
      ...selectedDrink,
      quantity: selectedQuantity,
      totalPrice: (parseFloat(selectedDrink.price) * selectedQuantity).toFixed(2)
    };
    
    // Reset states
    setShowOrderConfirmation(false);
    setShowQuantitySelector(false);
    
    // Send the enhanced drink data for payment processing
    onSendMessage(JSON.stringify(enhancedDrink), 'enhanced-selection');
  };

  // Handle payment form submission
  const handlePaymentSubmit = (e, paymentData) => {
    e.preventDefault();
    
    // Validate form fields
    if (!paymentDetails.cardNumber || !paymentDetails.expiryDate || !paymentDetails.cvv || !paymentDetails.name) {
      alert("Please fill in all payment fields.");
      return;
    }
    
    // Send payment details to parent component
    onSendMessage(JSON.stringify(paymentDetails), 'payment-submit');
    
    // Reset form
    setPaymentDetails({
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      name: ""
    });
  };

  // Handle vendor menu close
  const handleVendorMenuClose = () => {
    setShowVendorMenu(false);
    setSelectedVendor(null);
  };

  // Handle vendor order completion
  const handleVendorOrderComplete = (orderResult) => {
    console.log('Vendor order completed:', orderResult);
    setShowVendorMenu(false);
    setSelectedVendor(null);
    
    // Send success message to chat
    onSendMessage(`Great! Your order from ${selectedVendor?.name} has been placed successfully. Order ID: ${orderResult.orderId}`);
  };

  // Handle payment cancellation
  const handlePaymentCancel = (e) => {
    e.preventDefault();
    onSendMessage('cancelled', 'payment-cancel');
    
    // Reset form
    setPaymentDetails({
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      name: ""
    });
  };

  // Render quantity selector
  const renderQuantitySelector = () => {
    if (!showQuantitySelector || !selectedDrink || showFestivalGuide || showFeaturedVendors || showFestivalMap) return null;
    
    return (
      <QuantitySelector>
        <QuantityTitle>How many would you like to order?</QuantityTitle>
        <QuantityButtons>
          {[1, 2, 3, 4].map(qty => (
            <QuantityButton 
              key={qty} 
              selected={selectedQuantity === qty}
              onClick={() => handleQuantitySelect(qty)}
            >
              {qty}
            </QuantityButton>
          ))}
        </QuantityButtons>
        <ButtonGroup>
          <ActionButton onClick={() => setShowQuantitySelector(false)}>
            Cancel
          </ActionButton>
          <ActionButton onClick={handleConfirmQuantity}>
            Confirm
          </ActionButton>
        </ButtonGroup>
      </QuantitySelector>
    );
  };

  // Render order confirmation with upsell
  const renderOrderConfirmation = () => {
    if (!showOrderConfirmation || !selectedDrink || showFestivalGuide || showFeaturedVendors || showFestivalMap) return null;
    
    const totalPrice = (parseFloat(selectedDrink.price) * selectedQuantity).toFixed(2);
    
    return (
      <OrderSummary>
        <QuantityTitle>Confirm Your Order</QuantityTitle>
        <OrderSummaryItem>
          <span>{selectedDrink.name}</span>
          <span>${selectedDrink.price}</span>
        </OrderSummaryItem>
        <OrderSummaryItem>
          <span>Quantity</span>
          <span>{selectedQuantity}</span>
        </OrderSummaryItem>
        <OrderTotal>
          <span>Total</span>
          <span>${totalPrice}</span>
        </OrderTotal>
        
        {/* Upsell section */}
        <UpsellContainer>
          <UpsellTitle>Would you like to add anything else?</UpsellTitle>
          <UpsellButtons>
            <ActionButton onClick={() => onButtonClick('show_food_menu')}>
              Add Food
            </ActionButton>
            <ActionButton onClick={() => onButtonClick('show_drinks')}>
              Add More Drinks
            </ActionButton>
            <ActionButton onClick={() => onButtonClick('show_desserts')}>
              Add Dessert
            </ActionButton>
          </UpsellButtons>
        </UpsellContainer>
        
        <ButtonGroup>
          <ActionButton onClick={() => {
            setShowOrderConfirmation(false);
            setShowQuantitySelector(true);
          }}>
            Edit
          </ActionButton>
          <GoldButton onClick={handleProceedToPayment}>
            Proceed to Payment
          </GoldButton>
        </ButtonGroup>
      </OrderSummary>
    );
  };

  // Render menu categories
  const renderDynamicMenuCategories = () => {
    if (menuCategories.length === 0) {
      return <p style={{ color: '#AAA', fontStyle: 'italic' }}>Loading menu categories...</p>;
    }

    return (
      <CategorySelector>
        {menuCategories.map(category => (
          <CategoryButton 
            key={category.id}
            className={selectedCategory === category.id ? 'active' : ''}
            onClick={() => handleCategorySelect(category.id)}
          >
            {category.name}
          </CategoryButton>
        ))}
      </CategorySelector>
    );
  };

  // Menu functionality removed - POS systems handle menus
  const renderMenuItems = () => {
    return <p style={{ color: '#AAA', fontStyle: 'italic' }}>Menu available through POS systems</p>;
  };

  // Render the payment form
  const renderPaymentForm = (message) => {
    const { paymentData } = message;
    
    // Support for quantity-based pricing
    const totalAmount = paymentData.totalPrice || paymentData.amount;
    const itemName = paymentData.quantity 
      ? `${paymentData.drinkName || paymentData.name} (x${paymentData.quantity})`
      : (paymentData.drinkName || paymentData.name);
    
    return (
      <PaymentFormContainer>
        <PaymentFormTitle>Payment Details</PaymentFormTitle>
        
        <OrderSummary>
          <p style={{ marginBottom: '8px', fontWeight: '500' }}>Order Summary</p>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{itemName}</span>
            <span style={{ fontWeight: 'bold', color: '#D4AF37' }}>${totalAmount}</span>
          </div>
        </OrderSummary>
        
        <form onSubmit={(e) => handlePaymentSubmit(e, paymentData)}>
          <FormGroup>
            <FormLabel>Cardholder Name</FormLabel>
            <FormInput 
              type="text"
              placeholder="John Doe"
              value={paymentDetails.name}
              onChange={(e) => handlePaymentInputChange('name', e.target.value)}
              disabled={isProcessing}
            />
          </FormGroup>
          
          <FormGroup>
            <FormLabel>Card Number</FormLabel>
            <FormInput 
              type="text"
              placeholder="1234 5678 9012 3456"
              value={paymentDetails.cardNumber}
              onChange={(e) => handlePaymentInputChange('cardNumber', e.target.value)}
              maxLength="19"
              disabled={isProcessing}
            />
          </FormGroup>
          
          <FormRow>
            <FormColumn>
              <FormLabel>Expiry Date</FormLabel>
              <FormInput 
                type="text"
                placeholder="MM/YY"
                value={paymentDetails.expiryDate}
                onChange={(e) => handlePaymentInputChange('expiryDate', e.target.value)}
                maxLength="5"
                disabled={isProcessing}
              />
            </FormColumn>
            
            <FormColumn>
              <FormLabel>CVV</FormLabel>
              <FormInput 
                type="password"
                placeholder="123"
                value={paymentDetails.cvv}
                onChange={(e) => handlePaymentInputChange('cvv', e.target.value)}
                maxLength="4"
                disabled={isProcessing}
              />
            </FormColumn>
          </FormRow>
          
          <PaymentFormButtons>
            <CancelButton 
              type="button" 
              onClick={handlePaymentCancel}
              disabled={isProcessing}
            >
              Cancel
            </CancelButton>
            <PayButton 
              type="submit"
              disabled={isProcessing}
            >
              {isProcessing ? 'Processing...' : `Pay ${totalAmount}`}
            </PayButton>
          </PaymentFormButtons>
        </form>
      </PaymentFormContainer>
    );
  };

  // Render message content based on message type
  const renderMessageContent = (message) => {
    // Handle payment form
    if (message.showPaymentForm && message.paymentData) {
      return (
        <>
          <p>{message.text}</p>
          {renderPaymentForm(message)}
        </>
      );
    }

    if (message.preferenceQuestion) {
      return (
        <>
          <p>{message.text}</p>
          <PreferenceQuestion 
            question={message.text}
            options={message.options}
            onSelect={(optionId) => {
              const actionType = `preference_${message.questionId}_${optionId}`;
              onButtonClick(actionType);
            }}
          />
        </>
      );
    }
    
    // Menu display removed - POS systems handle menus
    if (false) {
      return (
        <DrinkMenu>
          <p style={{ marginBottom: '8px', fontWeight: '500', color: 'white' }}>What would you like to order?</p>
          {renderDynamicMenuCategories()}
          {renderMenuItems()}
        </DrinkMenu>
      );
    }
    
    // Handle drink search
    if (message.showDrinkMenu) {
      return (
        <DrinkMenu>
          <DrinkSearchAutocomplete onSelect={(drink) => handleDrinkSelection(JSON.stringify(drink))} />
        </DrinkMenu>
      );
    }
    
    // Handle vendor marketplace
    if (message.showVendorMarketplace) {
      return (
        <>
          <p>{message.text}</p>
          <ButtonGroup>
            <ActionButton onClick={() => onButtonClick('show_vendor_marketplace')}>
              🎪 Open Live Vendor Marketplace
            </ActionButton>
          </ButtonGroup>
        </>
      );
    }
    
    // Handle history items
    if (message.historyItems && message.historyItems.length > 0) {
      return (
        <>
          <p>{message.text}</p>
          <HistoryTitle>Your Previous Order:</HistoryTitle>
          <HistoryItemsContainer>
            {message.historyItems.map((item, idx) => (
              <HistoryItem key={idx}>
                <HistoryItemDetails>
                  <HistoryItemName>
                    {item.quantity > 1 ? `${item.quantity}x ` : ''}
                    {item.name}
                  </HistoryItemName>
                  {item.type && <HistoryItemType>{item.type}</HistoryItemType>}
                </HistoryItemDetails>
                <HistoryItemPrice>${parseFloat(item.price).toFixed(2)}</HistoryItemPrice>
                <ReorderButton onClick={() => onButtonClick('reorder_item', item)}>
                  Reorder
                </ReorderButton>
              </HistoryItem>
            ))}
          </HistoryItemsContainer>
          {message.buttons && (
            <ButtonGroup>
              {message.buttons.map((button, btnIndex) => (
                <ActionButton
                  key={btnIndex}
                  onClick={() => onButtonClick(button.action, button.data)}
                >
                  {button.text}
                </ActionButton>
              ))}
            </ButtonGroup>
          )}
        </>
      );
    }
    
    // Default message content
    return (
      <>
        <p>{message.text}</p>
        {message.buttons && (
          <ButtonGroup>
            {message.buttons.map((button, btnIndex) => (
              <ActionButton
                key={btnIndex}
                onClick={() => {
                  console.log("Button clicked:", button.action, button.text);
                  
                  // Check for button actions
                  if (button.action === "help me decide" || 
                      button.text === "Help Me Decide") {
                    console.log("Setting showFestivalGuide to true");
                    setShowFestivalGuide(true);
                  } else if (button.action === "featured_vendors" || 
                             button.text === "Featured Food Trucks & Vendors") {
                    console.log("Setting showFeaturedVendors to true");
                    setShowFeaturedVendors(true);
                  } else if (button.action === "festival_map" || 
                             button.text === "Festival Map") {
                    console.log("Setting showFestivalMap to true");
                    setShowFestivalMap(true);
                  } else if (message.requiresPayment) {
                    if (button.action === "show_menu") {
                      onButtonClick(button.action);
                    } else {
                      onSendMessage(button.action);
                    }
                  } else {
                    onButtonClick(button.action);
                  }
                }}
              >
                {button.text}
              </ActionButton>
            ))}
          </ButtonGroup>
        )}
        {message.drinks && (
          <DrinkMenu>
            {message.drinks.map((drink, index) => (
              <DrinkItem key={index} onClick={() => handleDrinkSelection(JSON.stringify(drink))}>
                <DrinkDetails>
                  <h4>{drink.name}</h4>
                  <p>{drink.description}</p>
                </DrinkDetails>
                <DrinkPrice>${drink.price}</DrinkPrice>
              </DrinkItem>
            ))}
          </DrinkMenu>
        )}
        {message.categoryItems && (
          <DrinkMenu>
            <p style={{ marginBottom: '8px', fontWeight: '500', color: 'white' }}>
              {message.categoryName.charAt(0).toUpperCase() + 
               message.categoryName.slice(1).replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim()}
            </p>
            {message.categoryItems.map((item, index) => (
              <DrinkItem key={index} onClick={() => handleDrinkSelection(JSON.stringify(item))}>
                <DrinkDetails>
                  <h4>{item.name}</h4>
                  {item.description && <p>{item.description}</p>}
                </DrinkDetails>
                <DrinkPrice>${parseFloat(item.price).toFixed(2)}</DrinkPrice>
              </DrinkItem>
            ))}
          </DrinkMenu>
        )}
      </>
    );
  };
  
  // Check if any message contains an active payment form
  const hasActivePaymentForm = messages.some(message => 
    message.showPaymentForm && message.paymentData && isProcessing
  );

  // Check if any overlay is active
  const hasActiveOverlay = showFestivalGuide || showFeaturedVendors || showFestivalMap;

  /* 
  ================================
  HIDDEN CONVERSATIONAL CHAT FLOW
  ================================
  This section contains the conversational chat interface logic
  that was previously used. It's commented out for future use
  but can be re-enabled by uncommenting this block.
  
  Features included:
  - Natural language conversation flow
  - Message bubbles with avatars
  - Real-time typing indicators
  - Contextual responses
  - Multi-turn dialogue handling
  
  To re-enable: uncomment the entire block below
  
  const [showConversationalMode, setShowConversationalMode] = useState(false);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  
  const handleConversationalInput = (userInput) => {
    // Add user message to history
    setConversationHistory(prev => [...prev, {
      sender: 'user',
      message: userInput,
      timestamp: new Date()
    }]);
    
    // Simulate bot typing
    setIsTyping(true);
    
    // Process natural language input
    setTimeout(() => {
      const botResponse = processBotResponse(userInput);
      setConversationHistory(prev => [...prev, {
        sender: 'bot',
        message: botResponse,
        timestamp: new Date()
      }]);
      setIsTyping(false);
    }, 1500);
  };
  
  const processBotResponse = (input) => {
    // Natural language processing logic here
    // This would handle contextual responses, recommendations, etc.
    return "I understand you're looking for something special. Let me help you find the perfect option.";
  };
  
  const renderConversationalInterface = () => {
    if (!showConversationalMode) return null;
    
    return (
      <ConversationalContainer>
        <ConversationHeader>
          <h3>Chat with our Festival Guide</h3>
          <CloseButton onClick={() => setShowConversationalMode(false)}>×</CloseButton>
        </ConversationHeader>
        
        <ConversationMessages>
          {conversationHistory.map((msg, index) => (
            <ConversationBubble key={index} sender={msg.sender}>
              <Avatar src={msg.sender === 'bot' ? womanProfileIcon : null} />
              <MessageText>{msg.message}</MessageText>
            </ConversationBubble>
          ))}
          {isTyping && (
            <TypingIndicator>
              <Avatar src={womanProfileIcon} />
              <TypingDots>...</TypingDots>
            </TypingIndicator>
          )}
        </ConversationMessages>
        
        <ConversationInput>
          <InputField 
            placeholder="Ask me anything about the festival..."
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleConversationalInput(e.target.value);
                e.target.value = '';
              }
            }}
          />
        </ConversationInput>
      </ConversationalContainer>
    );
  };
  
  END OF HIDDEN CONVERSATIONAL CHAT FLOW
  ======================================
  */
  
  return (
    <ChatContainer>
      <Logo src={ezdrinkLogo} alt="PourPal Logo" />
      
      {/* NEW: Connection Status Indicator */}
      <div style={{ 
        background: '#1a1a1a', 
        border: '1px solid #333', 
        borderRadius: '6px', 
        padding: '8px 12px', 
        margin: '10px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px' 
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: vendorsError ? '#ff6b6b' : (realVendors.length > 0 ? '#4CAF50' : '#FFA726')
          }}></div>
          <span style={{ 
            color: '#ccc', 
            fontSize: '12px' 
          }}>
            {vendorsError ? 'Connection Error' : 
             (realVendors.length > 0 ? `${realVendors.length} vendors connected` : 'Connecting to vendor system...')}
          </span>
        </div>
        
        {realVendors.length > 0 && (
          <span style={{ 
            color: '#4CAF50', 
            fontSize: '10px',
            fontWeight: 'bold'
          }}>
            LIVE
          </span>
        )}
        
        {/* NEW: Real-time indicator */}
        {realVendors.length > 0 && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '4px' 
          }}>
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: isRealTimeConnected ? '#4CAF50' : '#666',
              animation: isRealTimeConnected ? 'pulse 1s infinite' : 'none'
            }}></div>
            <span style={{ 
              color: isRealTimeConnected ? '#4CAF50' : '#666', 
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              {isRealTimeConnected ? 'REAL-TIME' : 'POLLING'}
            </span>
          </div>
        )}
      </div>
      
      {/* NEW: New Vendor Notification */}
      {showNewVendorNotification && (
        <div style={{ 
          background: 'linear-gradient(135deg, #4CAF50, #45a049)', 
          border: '1px solid #4CAF50', 
          borderRadius: '8px', 
          padding: '12px 16px', 
          margin: '10px 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          animation: 'slideIn 0.3s ease-out'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px' 
          }}>
            <span style={{ fontSize: '18px' }}>🎉</span>
            <div>
              <div style={{ 
                color: 'white', 
                fontSize: '14px', 
                fontWeight: 'bold',
                marginBottom: '2px'
              }}>
                New Vendor Connected!
              </div>
              <div style={{ 
                color: 'rgba(255,255,255,0.9)', 
                fontSize: '12px' 
              }}>
                A new vendor has joined the platform
              </div>
            </div>
          </div>
          
          <button
            onClick={() => setShowNewVendorNotification(false)}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '4px 8px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            ✕
          </button>
        </div>
      )}
      
      {/* NEW: Real Vendors Display Section */}
      {realVendors.length > 0 && (
        <div style={{ 
          background: '#1a1a1a', 
          border: '1px solid #D4AF37', 
          borderRadius: '8px', 
          padding: '15px', 
          margin: '15px 0',
          position: 'relative'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '15px' 
          }}>
            <h4 style={{ 
              color: '#D4AF37', 
              margin: 0, 
              fontSize: '16px', 
              fontWeight: 'bold' 
            }}>
              🎪 Connected Vendors ({realVendors.length})
            </h4>
            <button
              onClick={refreshVendors}
              disabled={vendorsLoading}
              style={{
                background: '#D4AF37',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                fontSize: '12px',
                cursor: vendorsLoading ? 'not-allowed' : 'pointer',
                opacity: vendorsLoading ? 0.6 : 1
              }}
            >
              {vendorsLoading ? '🔄' : '🔄 Refresh'}
            </button>
          </div>
          
          {vendorsError && (
            <div style={{ 
              color: '#ff6b6b', 
              fontSize: '12px', 
              marginBottom: '10px',
              padding: '8px',
              background: '#2a1a1a',
              borderRadius: '4px',
              border: '1px solid #ff6b6b'
            }}>
              ⚠️ Error: {vendorsError}
            </div>
          )}
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '10px' 
          }}>
            {realVendors.map((vendor) => (
              <div
                key={vendor.id}
                style={{
                  background: '#222',
                  border: '1px solid #333',
                  borderRadius: '6px',
                  padding: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#D4AF37';
                  e.target.style.background = '#2a2a2a';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(212, 175, 55, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#333';
                  e.target.style.background = '#222';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
                onClick={() => {
                  console.log('Vendor selected:', vendor);
                  // Handle vendor selection - could show menu, details, etc.
                  onButtonClick('vendor_selected', vendor);
                }}
                title={`Click to view ${vendor.name}'s details`}
              >
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'flex-start',
                  marginBottom: '8px'
                }}>
                  <h5 style={{ 
                    color: '#D4AF37', 
                    margin: 0, 
                    fontSize: '14px', 
                    fontWeight: 'bold' 
                  }}>
                    {vendor.name}
                  </h5>
                  {vendor.posSystem && (
                    <span style={{
                      background: '#D4AF37',
                      color: 'black',
                      padding: '2px 6px',
                      borderRadius: '10px',
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}>
                      {vendor.posSystem === 'eventbridge' ? 'Square' : vendor.posSystem}
                    </span>
                  )}
                </div>
                
                <p style={{ 
                  color: '#ccc', 
                  margin: '0 0 8px 0', 
                  fontSize: '12px', 
                  lineHeight: '1.3' 
                }}>
                  {vendor.description}
                </p>
                
                {vendor.location && (
                  <div style={{ 
                    color: '#888', 
                    fontSize: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    marginBottom: '6px'
                  }}>
                    📍 {vendor.location}
                  </div>
                )}
                
                {vendor.specialties && vendor.specialties.length > 0 && (
                  <div style={{ 
                    marginBottom: '6px' 
                  }}>
                    <div style={{ 
                      color: '#D4AF37', 
                      fontSize: '10px', 
                      fontWeight: 'bold',
                      marginBottom: '2px'
                    }}>
                      Specialties:
                    </div>
                    <div style={{ 
                      color: '#aaa', 
                      fontSize: '10px' 
                    }}>
                      {vendor.specialties.slice(0, 3).join(' • ')}
                      {vendor.specialties.length > 3 && '...'}
                    </div>
                  </div>
                )}
                
                {vendor.onboardingDate && (
                  <div style={{ 
                    color: '#666', 
                    fontSize: '10px',
                    marginTop: '6px',
                    borderTop: '1px solid #333',
                    paddingTop: '6px'
                  }}>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <span>Connected: {new Date(vendor.onboardingDate).toLocaleDateString()}</span>
                      <span style={{ 
                        color: '#4CAF50', 
                        fontSize: '8px',
                        fontWeight: 'bold'
                      }}>
                        ACTIVE
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          {lastVendorRefresh && (
            <div style={{ 
              color: '#666', 
              fontSize: '10px', 
              textAlign: 'center', 
              marginTop: '10px',
              fontStyle: 'italic'
            }}>
              Last updated: {lastVendorRefresh.toLocaleTimeString()}
            </div>
          )}
          
          {/* NEW: Vendor Statistics Summary */}
          <div style={{ 
            background: '#222', 
            border: '1px solid #333', 
            borderRadius: '6px', 
            padding: '12px', 
            marginTop: '15px'
          }}>
            <div style={{ 
              color: '#D4AF37', 
              fontSize: '12px', 
              fontWeight: 'bold',
              marginBottom: '8px',
              textAlign: 'center'
            }}>
              📊 Connection Summary
            </div>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', 
              gap: '10px',
              textAlign: 'center'
            }}>
              <div>
                <div style={{ 
                  color: '#4CAF50', 
                  fontSize: '18px', 
                  fontWeight: 'bold' 
                }}>
                  {realVendors.length}
                </div>
                <div style={{ 
                  color: '#888', 
                  fontSize: '10px' 
                }}>
                  Total Vendors
                </div>
              </div>
              
              <div>
                <div style={{ 
                  color: '#D4AF37', 
                  fontSize: '18px', 
                  fontWeight: 'bold' 
                }}>
                  {realVendors.filter(v => v.posSystem === 'eventbridge').length}
                </div>
                <div style={{ 
                  color: '#888', 
                  fontSize: '10px' 
                }}>
                  Square Connected
                </div>
              </div>
              
              <div>
                <div style={{ 
                  color: '#FFA726', 
                  fontSize: '18px', 
                  fontWeight: 'bold' 
                }}>
                  {realVendors.filter(v => v.featured).length}
                </div>
                <div style={{ 
                  color: '#888', 
                  fontSize: '10px' 
                }}>
                  Featured
                </div>
              </div>
              
              <div>
                <div style={{ 
                  color: '#4CAF50', 
                  fontSize: '18px', 
                  fontWeight: 'bold' 
                }}>
                  {realVendors.filter(v => v.isOpen).length}
                </div>
                <div style={{ 
                  color: '#888', 
                  fontSize: '10px' 
                }}>
                  Currently Open
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* NEW: Vendor Connection History */}
      {realVendors.length > 0 && (
        <div style={{ 
          background: '#1a1a1a', 
          border: '1px solid #333', 
          borderRadius: '8px', 
          padding: '15px', 
          margin: '15px 0'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '15px' 
          }}>
            <h4 style={{ 
              color: '#D4AF37', 
              margin: 0, 
              fontSize: '14px', 
              fontWeight: 'bold' 
            }}>
              🔗 Recent Connections
            </h4>
            <span style={{ 
              color: '#666', 
              fontSize: '10px' 
            }}>
              Last 24 hours
            </span>
          </div>
          
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '8px' 
          }}>
            {realVendors
              .sort((a, b) => new Date(b.onboardingDate) - new Date(a.onboardingDate))
              .slice(0, 3)
              .map((vendor) => (
                <div
                  key={vendor.id}
                  style={{
                    background: '#222',
                    border: '1px solid #333',
                    borderRadius: '4px',
                    padding: '8px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                  }}>
                    <div style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      background: '#4CAF50'
                    }}></div>
                    <span style={{ 
                      color: '#D4AF37', 
                      fontSize: '12px', 
                      fontWeight: '500' 
                    }}>
                      {vendor.name}
                    </span>
                  </div>
                  
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                  }}>
                    <span style={{
                      background: '#333',
                      color: '#ccc',
                      padding: '2px 6px',
                      borderRadius: '8px',
                      fontSize: '10px'
                    }}>
                      {vendor.posSystem === 'eventbridge' ? 'Square' : vendor.posSystem}
                    </span>
                    
                    <span style={{ 
                      color: '#666', 
                      fontSize: '10px' 
                    }}>
                      {vendor.onboardingDate ? 
                        new Date(vendor.onboardingDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : 
                        'Unknown'
                      }
                    </span>
                  </div>
                </div>
              ))}
          </div>
          
          {realVendors.length > 3 && (
            <div style={{ 
              textAlign: 'center', 
              marginTop: '10px' 
            }}>
              <span style={{ 
                color: '#666', 
                fontSize: '10px' 
              }}>
                +{realVendors.length - 3} more vendors connected
              </span>
            </div>
          )}
        </div>
      )}
      
      {/* NEW: Vendor Connection Logs */}
      {realVendors.length > 0 && (
        <div style={{ 
          background: '#1a1a1a', 
          border: '1px solid #333', 
          borderRadius: '8px', 
          padding: '15px', 
          margin: '15px 0'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '15px' 
          }}>
            <h4 style={{ 
              color: '#D4AF37', 
              margin: 0, 
              fontSize: '14px', 
              fontWeight: 'bold' 
            }}>
              📋 System Logs
            </h4>
            <span style={{ 
              color: '#666', 
              fontSize: '10px' 
            }}>
              Last 5 events
            </span>
          </div>
          
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '6px',
            maxHeight: '120px',
            overflowY: 'auto'
          }}>
            <div style={{
              background: '#222',
              border: '1px solid #333',
              borderRadius: '4px',
              padding: '6px 8px',
              fontSize: '10px',
              color: '#4CAF50'
            }}>
              ✅ {new Date().toLocaleTimeString()} - Customer-bridge-lambda connected successfully
            </div>
            
            <div style={{
              background: '#222',
              border: '1px solid #333',
              borderRadius: '4px',
              padding: '6px 8px',
              fontSize: '10px',
              color: '#D4AF37'
            }}>
              🔄 {new Date(Date.now() - 30000).toLocaleTimeString()} - Vendor list refreshed ({realVendors.length} vendors)
            </div>
            
            {realVendors.slice(0, 3).map((vendor, index) => (
              <div
                key={`log-${vendor.id}`}
                style={{
                  background: '#222',
                  border: '1px solid #333',
                  borderRadius: '4px',
                  padding: '6px 8px',
                  fontSize: '10px',
                  color: '#ccc'
                }}
              >
                🎪 {new Date(vendor.onboardingDate || Date.now() - (index + 1) * 60000).toLocaleTimeString()} - {vendor.name} connected via {vendor.posSystem === 'eventbridge' ? 'Square' : vendor.posSystem}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Show loading state when fetching vendors */}
      {vendorsLoading && realVendors.length === 0 && (
        <div style={{ 
          background: '#1a1a1a', 
          border: '1px solid #333', 
          borderRadius: '8px', 
          padding: '15px', 
          margin: '15px 0',
          textAlign: 'center'
        }}>
          <div style={{ color: '#D4AF37', marginBottom: '8px' }}>🔄</div>
          <p style={{ color: '#ccc', margin: 0, fontSize: '14px' }}>
            Connecting to vendor system...
          </p>
        </div>
      )}
      
      {/* Show error state when vendor fetch fails */}
      {vendorsError && realVendors.length === 0 && (
        <div style={{ 
          background: '#1a1a1a', 
          border: '1px solid #ff6b6b', 
          borderRadius: '8px', 
          padding: '15px', 
          margin: '15px 0',
          textAlign: 'center'
        }}>
          <div style={{ color: '#ff6b6b', marginBottom: '8px' }}>⚠️</div>
          <p style={{ color: '#ccc', margin: 0, fontSize: '14px' }}>
            Unable to load vendors
          </p>
          <button
            onClick={refreshVendors}
            style={{
              background: '#D4AF37',
              color: 'black',
              border: 'none',
              borderRadius: '4px',
              padding: '8px 16px',
              marginTop: '10px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Try Again
          </button>
        </div>
      )}
      
      <MessagesContainer>
        {messages.map((message, index) => (
          <MessageBubble key={index} sender={message.sender}>
            {message.sender === 'bot' && (
              <Avatar src={womanProfileIcon} alt="Bot Avatar" />
            )}
            <MessageContent>
              {renderMessageContent(message)}
            </MessageContent>
          </MessageBubble>
        ))}
        <div ref={messagesEndRef} />
      </MessagesContainer>
      
      {/* Show festival guide outside the message bubbles if enabled */}
      {showFestivalGuide && (
        <FestivalGuideOverlay>
          <FestivalGuideConversation 
            onSelectItem={handleItemFromGuide}
            onCancel={() => {
              console.log("Canceling festival guide");
              setShowFestivalGuide(false);
              onButtonClick('show_menu');
            }}
          />
        </FestivalGuideOverlay>
      )}
      
      {/* Show featured vendors outside the message bubbles if enabled */}
      {showFeaturedVendors && (
        <FestivalGuideOverlay>
          <FeaturedVendors 
            onSelectVendor={handleVendorFromFeatured}
            onCancel={() => {
              console.log("Canceling featured vendors");
              setShowFeaturedVendors(false);
            }}
          />
        </FestivalGuideOverlay>
      )}

      {/* Show festival map outside the message bubbles if enabled */}
      {showFestivalMap && (
        <FestivalGuideOverlay>
          <FestivalMap 
            onSelectVendor={handleVendorFromMap}
            onClose={() => {
              console.log("Closing festival map");
              setShowFestivalMap(false);
            }}
            globalCart={globalCart}
            onAddToGlobalCart={onAddToGlobalCart}
            onRemoveFromGlobalCart={onRemoveFromGlobalCart}
            onUpdateGlobalCartQuantity={onUpdateGlobalCartQuantity}
            getCartItemsForVendor={getCartItemsForVendor}
          />
        </FestivalGuideOverlay>
      )}

      {/* Show vendor menu outside the message bubbles if enabled */}
      {showVendorMenu && selectedVendor && (
        <FestivalGuideOverlay>
          <VendorMenu
            vendor={selectedVendor}
            onClose={handleVendorMenuClose}
            onOrderComplete={handleVendorOrderComplete}
            globalCart={globalCart}
            onAddToGlobalCart={onAddToGlobalCart}
            onRemoveFromGlobalCart={onRemoveFromGlobalCart}
            onUpdateGlobalCartQuantity={onUpdateGlobalCartQuantity}
            getCartItemsForVendor={getCartItemsForVendor}
          />
        </FestivalGuideOverlay>
      )}
      
      {/* Show quantity selector and order confirmation outside the message bubbles */}
      {renderQuantitySelector()}
      {renderOrderConfirmation()}
      
      {/* 
      Hidden conversational interface - uncomment to enable
      {renderConversationalInterface()}
      */}
      
      <InputArea>
        <form onSubmit={handleSubmit}>
          <InputRow>
            <InputField
              type={inputType === 'verification' ? 'number' : 'text'}
              value={input}
              onChange={handleInputChange}
              placeholder={
                inputType === 'phone' ? '(555) 555-5555' :
                inputType === 'verification' ? 'Enter verification code' :
                'Type your message...'
              }
              maxLength={inputType === 'phone' ? 14 : undefined}
              disabled={hasActivePaymentForm || showQuantitySelector || showOrderConfirmation || hasActiveOverlay}
            />
            <SendButton 
              type="submit" 
              disabled={hasActivePaymentForm || showQuantitySelector || showOrderConfirmation || hasActiveOverlay}
            >
              Send
            </SendButton>
          </InputRow>
        </form>
      </InputArea>
    </ChatContainer>
  );
};

export default ChatWindow;